import React, { useState, useRef, useEffect } from 'react';
import './companySearchBar.css';

const CompanySearchBar = ({ 
  onSearch, 
  onSubmit, 
  searchTerm, 
  searchResults, 
  loading, 
  error, 
  onSelectResult 
}) => {
  const [isResultsVisible, setIsResultsVisible] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
  const [showSpinner, setShowSpinner] = useState(false);
  const searchContainerRef = useRef(null);
  const inputRef = useRef(null);
  
  const handleInputChange = (event) => {
    setLocalSearchTerm(event.target.value);
  };

  const handleResultClick = (company, event) => {
    setLocalSearchTerm(company.name); 
    onSelectResult(company);
    if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
      setIsResultsVisible(false);
    }
  };

  const handleClickOutside = (event) => {
    if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
      setIsResultsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      onSearch(localSearchTerm);
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [localSearchTerm, onSearch]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); 
    }
  }, [localSearchTerm]);

  useEffect(() => {
    if (loading) {
      setShowSpinner(true); 
      const timer = setTimeout(() => {
        setShowSpinner(false); 
      }, 500000); 

      return () => clearTimeout(timer); 
    }
    setShowSpinner(false);
  }, [loading]);

  return (
    <div className="company-search-bar__container" ref={searchContainerRef}>
      <div className="company-search-bar__title-form-container">
        <h1>La receta perfecta para tu próximo trabajo</h1>
        <div className="company-search-bar__form-container">
          <div className="company-search-bar__input-container">
            <input
              type="text"
              placeholder="Busca empresas..."
              value={localSearchTerm}
              onChange={handleInputChange}
              className="company-search-bar__input"
              onFocus={() => setIsResultsVisible(!!localSearchTerm)} 
              ref={inputRef} 
            />
            <button 
              onClick={onSubmit}
              className="company-search-bar__button"
            >
              Buscar
            </button>
          </div>
          {showSpinner && <div className="company-search-bar__spinner"></div>}
          {error && <p>Error: {error.message}</p>}
          {isResultsVisible && searchResults.length === 0 && !loading && !error && (
            <p>No results found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanySearchBar;

